import create from 'zustand'

export const useGlobalStore = create(set => ({
  available: false,
  setAvailable: available => set({ available }),

  localTime: null,
  setLocalTime: localTime => set({ localTime }),
}))
